// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3s34Q","inner":"Footer_inner__1fztA","nextIcon":"Footer_nextIcon__2Gd_p","innerLeft":"Footer_innerLeft__3Iw6Z"};